// this component was coded by wilfred reign for portfolio presentation
// website:  www.wilfredreign.netlify.app
// facebook: wilfred reign
// contact : +27 61 202 3165
// whatsapp: +27 61 202 3165

import { Box } from "@mui/material";
import React from "react";
import PresentationNavigation from "./navigationButtons";
import { motion } from "framer-motion";
import Gene20Box from "../Gene20Box/Gene20Box";
import { staggerContainer } from "../../utils/motion";
import AboutStatement from "../AboutPageComponents/aboutStatement";

function PresentationHeader(props) {
  return (
    <Gene20Box
      sx={{
        padding: "8rem 0 2rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: { xs: "flex-end", sm: "center" },
        justifyItems: "center",
        margin: "auto",
        width: { xs: "100%", sm: "30vw" },
      }}
    >
      <motion.div
        variants={staggerContainer}
        initial="hidden"
        whileInView="show"
        viewport={{ once: false, amount: 0.25 }}
      >
        <AboutStatement />
        <Box sx={{mt:"5vh"}}>
          <PresentationNavigation
            phone={props.phone}
            tablet={props.tablet}
            laptop={props.laptop}
          />
        </Box>
      </motion.div>
    </Gene20Box>
  );
}

export default PresentationHeader;
